import { css } from 'styled-components';

export const ExtraVerification = css(
  ({ theme }) =>
    css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.large2}px;
    width: 100%;
    height: 479px;
  }

  div,h1 {
    font-family: 'Poppins';
    text-align: center;
  }
  .title {
    font-size: ${theme.font.size.mediumLarge};
    font-weight: 800;
  }
  .text {
    display: flex;
    flex-direction: column;
    text-align: center;
  }


  .explain-text{
    color: ${theme.colors.primary};
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    width:800px;
  }

  .send-link-btn {
    font-family: 'Poppins';
    font-size: ${theme.font.size.small};
    font-weight: 700;
    background-color: ${theme.colors.primaryLightBlue};
    border-radius: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 72px;
    gap: 10px;

    &:hover{
      &:before{
      border-radius: 50px;
      }
    }

  }
  `
);
